import { render, staticRenderFns } from "./BlockMobilePopup.vue?vue&type=template&id=7b815b92&scoped=true&"
import script from "./BlockMobilePopup.vue?vue&type=script&lang=js&"
export * from "./BlockMobilePopup.vue?vue&type=script&lang=js&"
import style0 from "./BlockMobilePopup.vue?vue&type=style&index=0&id=7b815b92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b815b92",
  null
  
)

component.options.__file = "BlockMobilePopup.vue"
export default component.exports